//$Id$
/**
 * @file client-storage
 * @summary Storage Types : Local storage, Session Storage, Cookie
 * @version 1.0.0
 * @notes Refer this image for Storage types & differences https://i.stack.imgur.com/sMNoo.png
 */

/**
 * Get data stored in the browser local storage
 * @param {string} key name of the key want to retrive
 * @returns {string} values assoicated with local storage key
 */
function getlocalItem(key){
    if (typeof(Storage)!=="undefined"){ //No I18N
        return localStorage.getItem(key);
    }
}

/**
 * Store value in browser local storage, which is accessible from other tabs
 * @param {string} key name of the key to create
 * @param {string} value value to create the key
 */
function setlocalItem(key,value){
    if (typeof(Storage)!=="undefined"){ //No I18N
      localStorage.setItem(key, value);
    }
}

/**
 * Removes the specified local storage object item
 * @param {string} key Requried. Name of the item want to remove
 */
function removelocalItem(key){
    if (typeof(Storage)!=="undefined"){ //No I18N
        localStorage.removeItem(key);
    }
}

/**
 * Removes all items from local storage
 */
function clearAllLocalStorage(){
    if (typeof(Storage)!=="undefined"){ //No I18N
    	var localJson = mergeDeep({},localStorage);
    	var keys = Object.keys(localJson);
    	for(var sAll = 0; sAll < keys.length; sAll++) {
		if (keys[sAll]!=undefined && keys[sAll].indexOf("persist") === -1 && keys[sAll].indexOf("tbprojidlist") === -1 && keys[sAll].indexOf("tbprojobj") === -1){
    			removelocalItem(keys[sAll]);
    		}
    	}
	}
}

/**
 * Get data stored in the browser session storage
 * @param {string} key name of the key want to retrive
 * @returns {string} values assoicated with session key
 */

function getSessionItem(key){
    return sessionStorage.getItem(key);
}

/**
 * Store value in session. Automatically Removed when tabs closed.
 * @param {string} key name of the key to create
 * @param {string} value value to create the key
 */
function setSessionItem(key,value){
	sessionStorage.setItem(key, value);
}

/**
 * Removes specified key and item from session
 * @param {string} key Requried. Name of the item want to remove
 */
function removeSessionItem(key){
    sessionStorage.removeItem(key);
}

/**
 * Removes all items from current session
 */
function clearAllSessionStorage(){
    if (typeof(Storage)!=="undefined"){ //No I18N
        for(var sAll = 0; sAll < sessionStorage.length; sAll++) {
            removeSessionItem(sessionStorage.key(sAll));
        }
        sessionStorage.clear();
    }
}

/**
 * Get cookie value by its name
 * @param {string} c_name name of the cookie
 * @returns {string} value of the cookie
 */
function getCookie(c_name) {  
	if (document.cookie.length > 0) {        
		c_start = document.cookie.indexOf(c_name + "=");         
		if (c_start !== -1) {   
			c_start = c_start + c_name.length + 1;   c_end = document.cookie.indexOf(";", c_start);            
			if (c_end === -1) {
				c_end = document.cookie.length;    
			}         
			return unescape(document.cookie.substring(c_start, c_end));         
		}     
	}     
	return ""; 
}

/**
 * Store value as cookie. It will expires in 180 days.
 * @param {string} c_name name of the cookie
 * @param {string} c_val value of the cookie
 */
function setCookie(c_name,c_val)
{
	var date = new Date( );
	date.setTime( date.getTime()+( 180*24*60*60*1000));
	var expires = "; expires="+date.toGMTString( );//No I18N
	document.cookie = c_name+"="+c_val+expires+"; secure=true; path=/";
}

Object.assign(window, {getlocalItem, setlocalItem, removelocalItem, clearAllLocalStorage, getSessionItem,
    setSessionItem, removeSessionItem, clearAllSessionStorage, getCookie, setCookie});